import React from 'react'
import styles from './modalWithBackground.jcss'

interface IModalWithBackgroundProps {
    isOpen: boolean
    onClose: () => void
    title?: string
    children?: React.ReactNode
}

const ModalWithBackground: React.FC<IModalWithBackgroundProps> = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null

    return (
        <div className={styles.wrapper} onClick={onClose}>
            <div className={styles.inner} onClick={(e) => e.stopPropagation()}>
                {title && <div className={styles.title}>{title}</div>}
                <div className={styles.content}>{children}</div>
            </div>
        </div>
    )
}

export default ModalWithBackground